import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import en from './locales/en.json';
import es from './locales/es.json';
import fr from './locales/fr.json';
import de from './locales/de.json';
import it from './locales/it.json';
import nl from './locales/nl.json';

const resources = {
  en: { translation: en },
  es: { translation: es },
  fr: { translation: fr },
  de: { translation: de },
  it: { translation: it },
  nl: { translation: nl }
};

const supportedLanguages = Object.keys(resources);

// Detect language: 1) localStorage (user's explicit choice), 2) browser language, 3) default 'en'
const getInitialLanguage = (): string => {
  if (typeof window === 'undefined') return 'en';

  // Check if user has explicitly selected a language before
  const saved = localStorage.getItem('i18nextLng');
  if (saved && supportedLanguages.includes(saved)) return saved;

  // Fall back to browser language (e.g. 'es-MX' → 'es')
  const browserLang = navigator.language?.split('-')[0];
  if (browserLang && supportedLanguages.includes(browserLang)) return browserLang;

  return 'en';
};

const initialLanguage = getInitialLanguage();

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: initialLanguage,
    fallbackLng: 'en',
    interpolation: { 
      escapeValue: false 
    },
    react: {
      useSuspense: false
    }
  });

export default i18n;
